// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"AttachmentsEdit_pageHeader__3SPEF AttachmentsList_pageHeader__18gDn","editSection":"AttachmentsEdit_editSection__3WNot"};